import createTableStore from "ds/components/Table/store/useTableStore";

import {
  API_KEYS_PERSONAL_COLUMN_CONFIG,
  API_KEYS_PERSONAL_COLUMNS_STORAGE_KEY,
} from "./constants";

const useApiKeysPersonalTableStore = createTableStore({
  storageKey: API_KEYS_PERSONAL_COLUMNS_STORAGE_KEY,
  config: API_KEYS_PERSONAL_COLUMN_CONFIG,
});

export default useApiKeysPersonalTableStore;
